<template>
  <div>
    <div class="aboutUs">
      <div class="section is-medium">
        <div class="container is-fluid">
          <div class="columns">
            <div class="column is-one-quarter">
              <h1 class="deneme">HAKKIMIZDA</h1>
            </div>
            <div class="column tile is-parent is-vertical">
              <p class="tile is-child">Günümüzde yaşanan teknolojik ve ekonomik değişimlerin etkileri, hukuk alanında da kendini göstermektedir. Bu etkiler, dinamik, açık görüşlü, yenilikleri ve teknolojik gelişmeleri yakından takip eden hukukçulara olan ihtiyacı da beraberinde getirmektedir. Sarıkaya + Şahin, bu ihtiyaca cevap verebilmeyi ve hizmet verdiği alanlarda daha iyiye ulaşmayı temel hedefi olarak belirlemektedir. </p>
              <p class="tile is-child">Sarıkaya + Şahin, gelişim ve değişimde sürekliliği sağlayarak müvekkillerinin hedeflerine ulaşmaları ve iş stratejilerini gerçekleştirmeleri için çeşitli ticari sektörlerde karşılaştıkları hukuki sorunlarına etkin çözümler sunar.</p>
              <p class="tile is-child">Sarıkaya + Şahin, hukuki sorunlara olan çözüm odaklı ve kişisel - kurumsal menfaat etkinliğini öne çıkaran yaklaşımları ile müvekkillerine karşı olan sorumluluklarını özenle yerine getirmektedir. Müvekkillerine gelişmekte olan sektörlerde olduğu kadar şirket danışmanlığı ve ticari uyuşmazlıklardaki deneyimleri ile de hukuki hizmet vermektedir.</p>
              <p class="tile is-child">Sarıkaya + Şahin, idari kurum ve kuruluşlarla ilişkiler, lisans, ruhsatlandırma ve izin prosedürlerinin takibi ve sonuçlandırılması konularında Ankara’da yirmi yılı aşkın süredir faaliyet gösteren Uğur Poyraz Hukuk Bürosu ile iş birliği yaparak; özel kişi girişimcilerden uluslararası yatırımcı ve holdinglere varıncaya kadar her ölçekten şirkete danışmanlık sağlamaktadır.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span class="uplogo"><img src="/static/upLogo.png"></span>
  </div>
</template>

<script>

  export default {
    name: 'hakkimizda',
    data() {
      return {

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .aboutUs p {
    font-size: 1.5rem;
    text-align: justify;
  }

  #app {
    background: #606c96;
  }

  .aboutUs h1::after {
    content: "";
    position: absolute;
    height: 5px;
    bottom: 0;
    left: 0;
    width: 40%;
    background: #81A716;
  }

  .aboutUs h1 {
    position: relative;
    color: #504f50;

    font-family: 'SEC', sans-serif;
  }

  .uplogo {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 22px;
    padding-bottom: 43px;
  }

  @media only screen and (max-width: 768px) {
    .uplogo {
      justify-content: center;
      margin-bottom: 100px;
    }
    .aboutUs p {
      font-size: 1.3rem;
    }
    .aboutUs h1 {
      font-size: 25px;
    }
    div.column.is-one-quarter::after {
      content: "";
      position: absolute;
      right: 12%;
      top: 0;
      height: 100%;
      background:unset;
      width: 1px;
    }
  }
</style>



// WEBPACK FOOTER //
// hakkimizda.vue?60c6fd66